// components/DateRangePicker/DateRangePicker.jsx
import React from 'react';
import { Form } from 'react-bootstrap';

const DateRangePicker = ({ start, end, onChange, placeholderFrom = 'від', placeholderTo = 'до' }) => {
  return (
    <div className="date-range-picker d-flex gap-2">
      <Form.Control
        type="date"
        value={start || ''}
        onChange={(e) => onChange(e.target.value, end)}
        placeholder={placeholderFrom}
        size="sm"
      />
      <Form.Control
        type="date"
        value={end || ''}
        onChange={(e) => onChange(start, e.target.value)}
        placeholder={placeholderTo}
        size="sm"
      />
    </div>
  );
};

export default DateRangePicker;